module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAjElEQVR42u3awQmAMAxA0exTXM4hu44jxJsUUZCeinmBf+shvEspNDIzKhcAAAAAAAAAAAAAAACYmtj71dG2x8YzCw0AAAAAAAAAAAAAAAAAAIhxydm+AKwSAAA3gLfl/xoAAAAAAHANAgDgMQQAAAAAAAAAAAAAAAAA1QH8FAUAAAAAAAAAAAAAoE4nrXz97EV/KcAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Faroes.png
// module id = y6vj
// module chunks = 0 62 63